import { useEffect, useCallback } from "react";

// 活动入口角标刷新事件名称：
// 当日/周救援金领取、VIP 签到、转盘抽奖等改变服务端状态的操作发生后，
// 各处（首页活动入口、左下角浮标等）据此重新拉取角标数据，无需刷新页面。
const ACTIVITY_BADGE_REFRESH_EVENT = "activity-badge:refresh";

/**
 * 触发活动入口角标刷新事件
 */
export const triggerActivityBadgeRefresh = () => {
  window.dispatchEvent(new CustomEvent(ACTIVITY_BADGE_REFRESH_EVENT));
};

/**
 * 监听活动入口角标刷新事件
 * @param callback 刷新回调函数
 */
export const useActivityBadgeRefresh = (
  callback: () => void | Promise<void>
) => {
  const handleRefresh = useCallback(() => {
    callback();
  }, [callback]);

  useEffect(() => {
    window.addEventListener(ACTIVITY_BADGE_REFRESH_EVENT, handleRefresh);
    return () => {
      window.removeEventListener(ACTIVITY_BADGE_REFRESH_EVENT, handleRefresh);
    };
  }, [handleRefresh]);
};
